import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../combosAction';
import ComboBusinessesOverridesForm from '../components/ComboBusinessesOverridesForm';
import {
  formatProductBusinessesAssigned,
  finalStructureSummaryData,
} from '../utils/helper';
import _ from 'lodash';

const ComboBusinessesOverridesContainer = ({
  combo,
  comboOverrides,
  getComboOverrides,
  comboBusinesses,
  allBusinesses,
  isSubmitting,
  reAssociateCombosOverrides,
}) => {
  const formattedBusinesses = useMemo(
    () => formatProductBusinessesAssigned(comboBusinesses, allBusinesses),
    [comboBusinesses, allBusinesses],
  );

  const [isCreate, setIsCreate] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const [summaryData, setSummaryData] = useState(null);

  const [isOverrideModal, setIsOverrideModal] = useState({
    isShowing: false,
    price: null,
    assignedBusinesses: [],
  });

  useEffect(() => {
    if (combo.id) {
      getComboOverrides(combo.id);
    }
  }, [combo.id, getComboOverrides]);

  useEffect(() => {
    if (comboOverrides && combo.id) {
      setSummaryData(
        finalStructureSummaryData(comboOverrides, formattedBusinesses),
      );
    }
  }, [comboOverrides, combo.id, formattedBusinesses]);

  const reAssociateOverrides = useCallback(() => {
    let updatedCombosBusinessOverrideIDs = [];
    let updatedCombosOverride = [];
    const currentCombosBusinessIDs = comboBusinesses?.map(
      (business) => business.business_id,
    );
    const currentCombosBusinessOverrideIDs = comboOverrides?.map(
      (business) => business.business_id,
    );
    if (
      currentCombosBusinessIDs?.length > 0 &&
      currentCombosBusinessOverrideIDs
    ) {
      currentCombosBusinessOverrideIDs.forEach((overrideId) => {
        if (currentCombosBusinessIDs.includes(overrideId)) {
          updatedCombosBusinessOverrideIDs.push(overrideId);
        }
      });
      if (
        !_.isEqual(
          currentCombosBusinessOverrideIDs,
          updatedCombosBusinessOverrideIDs,
        )
      ) {
        comboOverrides.forEach((override) => {
          if (updatedCombosBusinessOverrideIDs.includes(override.business_id)) {
            updatedCombosOverride.push({
              business_id: override.business_id,
              fixed_price: override.fixed_price,
            });
          }
        });
        reAssociateCombosOverrides(
          combo.id,
          updatedCombosOverride,
          false,
          true,
        );
      }
    }
  }, [comboBusinesses, comboOverrides, combo.id, reAssociateCombosOverrides]);

  useEffect(() => {
    reAssociateOverrides();
  }, [reAssociateOverrides]);

  return (
    <ComboBusinessesOverridesForm
      isExpanded={isExpanded}
      setIsExpanded={setIsExpanded}
      disabled={!combo.id}
      summaryData={summaryData}
      isOverrideModal={isOverrideModal}
      setIsOverrideModal={setIsOverrideModal}
      combo={combo}
      formattedBusinesses={formattedBusinesses}
      isCreate={isCreate}
      setIsCreate={setIsCreate}
      isSubmitting={isSubmitting}
      reAssociateCombosOverrides={reAssociateCombosOverrides}
      comboOverrides={comboOverrides}
    />
  );
};

const mapStateToProps = (state) => ({
  comboBusinesses: state.combosReducer.comboBusinesses,
  comboOverrides: state.combosReducer.comboOverrides,
  allBusinesses: state.businessLocationsList.businessLocationsOfMerchant,
  isSubmitting: state.combosReducer.isSubmitting,
});

export default connect(
  mapStateToProps,
  actions,
)(ComboBusinessesOverridesContainer);
